import { useMutation } from 'react-query'

import { attachmentRepository } from '@webapp/core/data-access/repositories/AttachmentRepository'
import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'

export interface UploadedInvoiceAttachment {
  uuid: string
  name: string
}

const readFileContent = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '')
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })

// Invoice uploads happen before the bill submit — the returned UUIDs are
// collected into the submit payload's invoice attachments.
export const useMutateUploadInvoiceAttachment = () => {
  const mutation = useMutation<UploadedInvoiceAttachment, RepoError, File>({
    mutationFn: async (file) => {
      const attachment = await attachmentRepository.upload({
        name: file.name,
        type: file.type,
        file: await readFileContent(file),
      })

      return { uuid: attachment.uuid, name: file.name }
    },
  })

  return {
    uploadInvoice: mutation.mutateAsync,
    isUploading: mutation.isLoading,
  }
}
